module.exports = __webpack_public_path__ + "static/img/card-title2.9b52ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card-title2.png
// module id = o+dG
// module chunks = 2